var render = function render(){var _vm=this,_c=_vm._self._c;return (!isNaN(this.$props.target))?_c('div',{staticClass:"loader-wrapper",style:(_vm.loaderStyle)},[_c('div',{staticClass:"h-full",attrs:{"id":"loader-target"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }